import { HttpInterceptorFn } from '@angular/common/http';

export const adminInterceptor: HttpInterceptorFn = (req, next) => {
  console.log('Interceptador acionado para a URL:', req.url);
  const modifiedRequest: any = req.clone({
    setHeaders: {
      'Authorization': localStorage.getItem('token') ?? '',
      'Content-Type': 'application/json'
    }
   
  }
    
  )
  console.log("Usando o interceptador...");
  return next(modifiedRequest);
};
